import { connect } from "react-redux";
import { title } from "store/title";

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  setHeadBar: title.actions.setHeadBar,
};

export default connect(mapStateToProps, mapDispatchToProps);
